import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { DismissibleAlert } from '@paypalcorp/pp-react';
import { MessageFormat } from '@paypalcorp/worldready';
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react';
import { onAlertClick } from './common';
import { trackEventWithData } from '../../fpti/analytics';
import { FPTI_SPEC } from '../../fpti/fptiConstants';

/**
 * VenmoAlert component displays a dismissible alert message for Venmo-related notifications.
 * It handles internationalization using WorldReady, tracks analytics events, and provides
 * a consistent alert UI with proper accessibility features.
 *
 * @param {string} type - The type of alert (default: 'error')
 * @param {string} messageId - The WorldReady message ID to display
 */
const VenmoAlert = ({ type = 'error', messageId }) => {
  const worldReady = useContext(WorldReadyContext);
  const closeButtonLabel = new MessageFormat(worldReady, {
    id: 'common.header.button.close',
  }).format();
  const message = new MessageFormat(worldReady, {
    id: messageId,
  }).format();
  trackEventWithData(FPTI_SPEC.LANDING_PAGE_VENMO_ALERT_SHOWN, {
    message,
  });
  return (
    <div className="mb-16">
      <DismissibleAlert
        type={type}
        closeButton={{
          'aria-label': closeButtonLabel,
          onClick: onAlertClick,
        }}
      >
        {message}
      </DismissibleAlert>
    </div>
  );
};

VenmoAlert.propTypes = {
  type: PropTypes.string,
  messageId: PropTypes.string,
};

export default VenmoAlert;
